define('AwaLabs.ShippingDeliveryLocation', [
    'js.cookie',
    'ShippingDeliveryLocation.View',
    'underscore',
    'SC.Configuration'
], function ShippingDeliveryLocation(
    Cookies,
    ShippingDeliveryLocationView,
    _,
    Configuration
) {
    'use strict';


    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getLayout();
            var deliveryShippingModal;
            if (SC.ENVIRONMENT.jsEnvironment === 'browser' &&
                !Cookies.get('is_displayed_shipping_delivery_modal') && Configuration.get('ShippingDeliveryLocation.activeModal', false)) {
                deliveryShippingModal = new ShippingDeliveryLocationView({
                    application: container
                });
                _.delay(function delay() {
                    layout.showInModal(deliveryShippingModal);
                }, Configuration.get('ShippingDeliveryLocation.delayTimeToShowModal', 1000));
            }
        }
    };
});
